import { defineComponent as _defineComponent } from 'vue'
import BCXMarkdown from '@/components/molecules/BCXMarkdown.vue';
import InvitesIcon from '@/components/svg/group.svg?inline';
import { Invitee } from '@/models/Invitation';
import { getInvitees } from '@/services/Invitation/Api';
import { onMounted, ref } from 'vue';
import InviteesTable from '@/views/invites/InviteesTable.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Invitees',
  setup(__props) {

const invitees = ref<Invitee[]>([]);

onMounted(async () => {
  invitees.value = (await getInvitees())?.inviteeList ?? [];
});


return { __sfc: true,invitees, BCXMarkdown, InvitesIcon, InviteesTable }
}

})